import React, { useMemo, useState } from 'react'
import { Tabs } from 'transfix-ui/components/Tabs'
import { TopNav } from 'transfix-ui/components/TopNav'
import { makeStyles } from 'transfix-ui/core'
import { IOfferedShipmentFilter } from 'types/FMSGraphqlTypes'
import ShipmentOffersTab from './components/ShipmentOffersTab'
import { useShipmentOfferCountsQuery } from './graphql/ShipmentOfferCounts'

const userShipmentOffersPageStyles = makeStyles(theme => ({
  pageContent: {
    padding: `${theme.spacing(10.75)} ${theme.spacing(2)} ${theme.spacing(4)}`,

    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(4)}`,
    },
  },
  tabs: {
    '& .MuiTab-root': {
      padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    },
  },
}))

const ShipmentOffersPage = () => {
  const [tab, setTab] = useState<IOfferedShipmentFilter>(IOfferedShipmentFilter.current)
  const classes = userShipmentOffersPageStyles()

  const { data, refetch } = useShipmentOfferCountsQuery({ fetchPolicy: 'cache-and-network' })
  const { currentOffers, pastOffers } = data || {}
  const { totalCount: availableLoadCount } = currentOffers || {}
  const { totalCount: unavailableLoadCount } = pastOffers || {}

  const tabChangeHandler = (newTab: string) => {
    setTab(newTab as IOfferedShipmentFilter)
  }

  const tabList = useMemo(
    () => [
      {
        tabId: IOfferedShipmentFilter.current,
        label: 'Available',
        count: availableLoadCount,
      },
      {
        tabId: IOfferedShipmentFilter.past,
        label: 'Unavailable',
        count: unavailableLoadCount,
      },
    ],
    [availableLoadCount, unavailableLoadCount]
  )

  return (
    <div>
      <TopNav title='Loads Offered to You' showMenu={false} showBackButton />
      <div className={classes.pageContent}>
        <Tabs
          activeTabId={tab}
          onChange={tabChangeHandler}
          tabList={tabList}
          indicatorColor='primary'
          textColor='primary'
          className={classes.tabs}>
          <ShipmentOffersTab filter={tab} onDeclineSuccess={refetch} />
        </Tabs>
      </div>
    </div>
  )
}

export default ShipmentOffersPage
